module.exports = __webpack_public_path__ + "assets/SS_vertex_upgrade.79e55295.svg";